import React from 'react';
import { useSelector } from 'react-redux';
import { useAdsType } from '@wix/da-ads/pkg/useAdsType';
import DesktopBrowseTop728x90 from '@wix/da-ads/pkg/adunits/anon/DesktopBrowseTop728x90';
import UserDesktopBrowseTop728x90 from '@wix/da-ads/pkg/adunits/user/DesktopBrowseTop728x90';
import { getCurrentAdSafety } from '@wix/da-shared-react/pkg/Ads/redux/selectors';
import PrimisTutorialsWrapper from '@wix/da-shared-react/pkg/Ads/PrimisTutorialsWrapper';
import cn from 'classnames';

import s from './TopAd.scss';

interface Props {}

const TopAd: React.FC<Props> = () => {
  const adSafety = useSelector(state => getCurrentAdSafety(state)) ?? 'off';
  const adsType = useAdsType();
  return (
    <div className={cn(s['root'], adsType === 'anon' && s['video'])}>
      {adsType === 'anon' && (
        <PrimisTutorialsWrapper hasPrimis>
          <DesktopBrowseTop728x90 safety={adSafety} />
        </PrimisTutorialsWrapper>
      )}
      {adsType === 'user' && <UserDesktopBrowseTop728x90 safety={adSafety} />}
    </div>
  );
};
TopAd.displayName = 'TopAd';

export default TopAd;
